(function () {
  if (window.__glowmJudgeMePaginationGalleryFallbackLoaded) {
    return;
  }

  window.__glowmJudgeMePaginationGalleryFallbackLoaded = true;
  window.__glowmJudgeMePaginationFallbackLoaded = true;

  var SELECTOR = '.jdgm-paginate__page:not(.jdgm-curt), .jdgm-paginate__load-more';
  var EXPANDED_GALLERY_STYLE_ID = 'glowm-judgeme-expanded-gallery-style';
  var FALLBACK_LIGHTBOX_ID = 'glowm-judgeme-fallback-lightbox';
  var FALLBACK_BACKDROP_ID = 'glowm-judgeme-fallback-backdrop';
  var MODAL_STYLE_ID = 'glowm-judgeme-modal-style';

  function closest(element, selector) {
    return element && element.closest ? element.closest(selector) : null;
  }

  function getWidget(element) {
    return closest(element, '.jdgm-review-widget, [data-widget="review"]') || closest(element, '.jdgm-rev-widg');
  }

  function getProductId(widget) {
    if (widget && (widget.dataset.productId || widget.dataset.id)) {
      return widget.dataset.productId || widget.dataset.id;
    }

    if (window.__st && window.__st.rtyp === 'product' && window.__st.rid) {
      return window.__st.rid;
    }

    if (window.meta && window.meta.product && window.meta.product.id) {
      return window.meta.product.id;
    }

    var productIdInput = document.querySelector('input[name="product-id"]');

    return productIdInput && productIdInput.value;
  }

  function getShopDomain() {
    if (window.Shopify && window.Shopify.shop) {
      return window.Shopify.shop;
    }

    return window.location.hostname;
  }

  function buildParams(widget, paginate, button) {
    var params = new URLSearchParams();
    var productId = getProductId(widget);
    var shopDomain = getShopDomain();
    var searchInput = widget.querySelector('.jdgm-review-search');
    var activeKeyword = widget.querySelector('.jdgm-keywords .jdgm-chip.active');
    var activeRating = widget.querySelector('.jdgm-histogram__row--selected');

    params.set('url', shopDomain);
    params.set('shop_domain', shopDomain);
    params.set('platform', 'shopify');
    params.set('page', button.dataset.page || '1');
    params.set('per_page', paginate.dataset.perPage || '5');

    if (productId) {
      params.set('product_id', productId);
    }

    if (widget.dataset.sortBy) {
      params.set('sort_by', widget.dataset.sortBy);
    }

    if (widget.dataset.sortDir) {
      params.set('sort_dir', widget.dataset.sortDir);
    }

    if (activeRating && activeRating.dataset.rating) {
      params.set('filter_rating', activeRating.dataset.rating);
    }

    if (searchInput && searchInput.value) {
      params.set('search', searchInput.value);
    }

    if (activeKeyword) {
      params.set('keyword', activeKeyword.dataset.text || activeKeyword.textContent.replace(/\(\d+\)/, '').trim());
    }

    return params;
  }

  function escapeAttribute(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function getGalleryReviews(dataElement) {
    if (!dataElement) {
      return [];
    }

    if (window.jdgm && window.jdgm.$) {
      try {
        var judgeMeData = window.jdgm.$(dataElement).data('json');

        if (Array.isArray(judgeMeData)) {
          return judgeMeData;
        }
      } catch (error) {
        // The raw data-json attribute below is enough when Judge.me's jQuery data parser is not ready.
      }
    }

    try {
      return JSON.parse(dataElement.getAttribute('data-json') || '[]');
    } catch (error) {
      return [];
    }
  }

  function getPictureUrl(picture, preferredSize) {
    if (!picture) {
      return '';
    }

    return picture[preferredSize] || picture.original || picture.huge || picture.compact || picture.url || '';
  }

  function ensureModalStyles() {
    if (document.getElementById(MODAL_STYLE_ID)) {
      return;
    }

    var style = document.createElement('style');
    style.id = MODAL_STYLE_ID;
    style.textContent =
      '.jm-mfp-wrap .jm-mfp-close,' +
      '.jm-mfp-close{' +
      'top:16px!important;right:16px!important;width:56px!important;height:56px!important;' +
      'padding:0!important;border-radius:0!important;border:0!important;' +
      'background:transparent!important;color:#fff!important;box-shadow:none!important;' +
      'font-size:36px!important;font-weight:400!important;line-height:52px!important;text-align:center!important;' +
      'text-shadow:0 2px 8px rgba(0,0,0,.72)!important;opacity:1!important;cursor:pointer!important;z-index:9999!important;' +
      '}' +
      '.jm-mfp-wrap .jm-mfp-close:hover,' +
      '.jm-mfp-close:hover{' +
      'background:transparent!important;border-color:transparent!important;outline:0!important;' +
      '}' +
      '.jm-mfp-wrap .jm-mfp-close:focus-visible,' +
      '.jm-mfp-close:focus-visible{' +
      'background:transparent!important;border-color:transparent!important;outline:2px solid #fff!important;' +
      'outline-offset:3px!important;' +
      '}' +
      '@media screen and (max-width:749px){' +
      '.jm-mfp-wrap .jm-mfp-close,.jm-mfp-close{top:calc(12px + env(safe-area-inset-top,0px))!important;' +
      'right:calc(12px + env(safe-area-inset-right,0px))!important;width:52px!important;height:52px!important;' +
      'font-size:34px!important;line-height:48px!important;}' +
      '}' +
      'html.glowm-judgeme-fallback-open,body.glowm-judgeme-fallback-open{overflow:hidden!important;}' +
      '.glowm-judgeme-fallback-backdrop,.glowm-judgeme-fallback-lightbox{position:absolute!important;inset:auto!important;' +
      'top:var(--glowm-fallback-top,0px)!important;left:var(--glowm-fallback-left,0px)!important;' +
      'width:var(--glowm-fallback-width,100vw)!important;height:var(--glowm-fallback-height,100vh)!important;}' +
      '.glowm-judgeme-fallback-backdrop{background:rgba(0,0,0,.86)!important;z-index:9998!important;}' +
      '.glowm-judgeme-fallback-lightbox{z-index:9999!important;display:flex!important;overflow:hidden!important;' +
      'align-items:center!important;justify-content:center!important;padding:88px 24px 32px!important;box-sizing:border-box!important;' +
      'overscroll-behavior:contain!important;}' +
      '@media screen and (max-width:749px){' +
      '.glowm-judgeme-fallback-lightbox{padding:calc(76px + env(safe-area-inset-top,0px)) 16px calc(24px + env(safe-area-inset-bottom,0px))!important;}' +
      '}' +
      '.glowm-judgeme-fallback-lightbox .jm-mfp-container{' +
      'width:100%!important;height:100%!important;display:flex!important;align-items:center!important;justify-content:center!important;' +
      '}' +
      '.glowm-judgeme-fallback-lightbox .jm-mfp-content,.glowm-judgeme-fallback-lightbox .jm-mfp-figure{' +
      'width:100%!important;height:100%!important;display:flex!important;align-items:center!important;justify-content:center!important;' +
      '}' +
      '.glowm-judgeme-fallback-lightbox .jm-mfp-img{display:block!important;width:auto!important;height:auto!important;' +
      'max-width:100%!important;max-height:100%!important;object-fit:contain!important;margin:auto!important;}';
    document.head.appendChild(style);
  }

  function ensureExpandedGalleryStyles() {
    if (document.getElementById(EXPANDED_GALLERY_STYLE_ID)) {
      return;
    }

    var style = document.createElement('style');
    style.id = EXPANDED_GALLERY_STYLE_ID;
    style.textContent =
      '.jdgm-gallery.jdgm-gallery--glowm-expanded .jdgm-gallery__thumbnail-link{' +
      'display:inline-block!important;visibility:visible!important;opacity:1!important;' +
      '}' +
      '.jdgm-gallery__thumbnail-link--glowm-more-used::before,' +
      '.jdgm-gallery__thumbnail-link--glowm-more-used::after,' +
      '.jdgm-gallery__thumbnail-link--glowm-more-used .jdgm-gallery__thumbnail-wrapper::before,' +
      '.jdgm-gallery__thumbnail-link--glowm-more-used .jdgm-gallery__thumbnail-wrapper::after{' +
      'content:""!important;background:transparent!important;color:transparent!important;box-shadow:none!important;' +
      '}';
    document.head.appendChild(style);
  }

  function isVisible(element) {
    if (!element) {
      return false;
    }

    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0;
  }

  function revealHiddenGalleryItems(event) {
    var link = closest(event.target, '.jdgm-gallery__thumbnail-link');
    var gallery = closest(event.target, '.jdgm-gallery');

    if (!link || !gallery || gallery.classList.contains('jdgm-gallery--glowm-expanded')) {
      return;
    }

    var links = Array.prototype.slice.call(gallery.querySelectorAll('.jdgm-gallery__thumbnail-link'));
    var visibleLinks = links.filter(isVisible);
    var hiddenLinks = links.filter(function (thumbnailLink) {
      return !isVisible(thumbnailLink);
    });

    if (!hiddenLinks.length || link !== visibleLinks[visibleLinks.length - 1]) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    ensureExpandedGalleryStyles();
    gallery.classList.add('jdgm-gallery--glowm-expanded');
    link.classList.add('jdgm-gallery__thumbnail-link--glowm-more-used');
    hiddenLinks.forEach(function (thumbnailLink) {
      thumbnailLink.style.display = 'inline-block';
      thumbnailLink.style.visibility = 'visible';
      thumbnailLink.style.opacity = '1';
    });

    window.setTimeout(function () {
      refreshJudgeMeEnhancements(getWidget(gallery) || gallery);
    }, 0);
  }

  function normalizeImageUrl(url) {
    if (!url) {
      return '';
    }

    try {
      var parsedUrl = new URL(url, window.location.href);
      parsedUrl.searchParams.delete('w');
      parsedUrl.searchParams.delete('width');
      return parsedUrl.href;
    } catch (error) {
      return String(url).replace(/([?&])(w|width)=\d+(&|$)/, '$1').replace(/[?&]$/, '');
    }
  }

  function getThumbnailFullSizeUrl(element) {
    var thumbnail = closest(element, '.jdgm-gallery__thumbnail');
    var link = closest(element, '.jdgm-gallery__thumbnail-link');

    if (!thumbnail && link) {
      thumbnail = link.querySelector('.jdgm-gallery__thumbnail');
    }

    return (
      (thumbnail && (thumbnail.getAttribute('data-mfp-src') || thumbnail.getAttribute('data-original-src'))) ||
      (link && (link.getAttribute('data-mfp-src') || link.getAttribute('href'))) ||
      (thumbnail && (thumbnail.getAttribute('data-src') || thumbnail.getAttribute('src'))) ||
      ''
    );
  }

  function syncOpenGalleryImage(expectedUrl) {
    var modalImage = document.querySelector('.jm-mfp-img');

    if (!modalImage || !expectedUrl) {
      return;
    }

    if (normalizeImageUrl(modalImage.getAttribute('src')) === normalizeImageUrl(expectedUrl)) {
      return;
    }

    modalImage.setAttribute('src', expectedUrl);
  }

  function getFallbackViewportRect() {
    if (window.visualViewport) {
      return {
        height: window.visualViewport.height,
        left: window.visualViewport.pageLeft,
        top: window.visualViewport.pageTop,
        width: window.visualViewport.width,
      };
    }

    return {
      height: window.innerHeight,
      left: window.pageXOffset,
      top: window.pageYOffset,
      width: window.innerWidth,
    };
  }

  function setFallbackViewport(element) {
    var viewport = getFallbackViewportRect();

    element.style.setProperty('--glowm-fallback-top', viewport.top + 'px');
    element.style.setProperty('--glowm-fallback-left', viewport.left + 'px');
    element.style.setProperty('--glowm-fallback-width', viewport.width + 'px');
    element.style.setProperty('--glowm-fallback-height', viewport.height + 'px');
  }

  function positionFallbackLightbox() {
    var lightbox = document.getElementById(FALLBACK_LIGHTBOX_ID);
    var backdrop = document.getElementById(FALLBACK_BACKDROP_ID);

    if (lightbox) {
      setFallbackViewport(lightbox);
    }

    if (backdrop) {
      setFallbackViewport(backdrop);
    }
  }

  function closeFallbackLightbox() {
    var lightbox = document.getElementById(FALLBACK_LIGHTBOX_ID);
    var backdrop = document.getElementById(FALLBACK_BACKDROP_ID);

    if (lightbox) {
      lightbox.remove();
    }

    if (backdrop) {
      backdrop.remove();
    }

    document.documentElement.classList.remove('glowm-judgeme-fallback-open');
    document.body.classList.remove('glowm-judgeme-fallback-open');
  }

  function openFallbackLightbox(imageUrl) {
    if (!imageUrl) {
      return;
    }

    ensureModalStyles();
    closeFallbackLightbox();

    var backdrop = document.createElement('div');
    backdrop.id = FALLBACK_BACKDROP_ID;
    backdrop.className = 'jm-mfp-bg jm-mfp-ready glowm-judgeme-fallback-backdrop';
    setFallbackViewport(backdrop);

    var lightbox = document.createElement('div');
    lightbox.id = FALLBACK_LIGHTBOX_ID;
    lightbox.className =
      'jm-mfp-wrap jm-mfp-gallery jm-mfp-close-btn-in jm-mfp-auto-cursor jm-mfp-ready glowm-judgeme-fallback-lightbox';
    setFallbackViewport(lightbox);
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Review image');
    lightbox.innerHTML = [
      "<div class='jm-mfp-container jm-mfp-image-holder jm-mfp-s-ready'>",
      "<div class='jm-mfp-content'>",
      "<div class='jm-mfp-figure'>",
      "<button type='button' class='jm-mfp-close' aria-label='Close'>×</button>",
      "<img class='jm-mfp-img' alt='Review image' src='",
      escapeAttribute(imageUrl),
      "' />",
      '</div>',
      '</div>',
      '</div>',
    ].join('');

    lightbox.addEventListener('click', function (event) {
      if (
        event.target === lightbox ||
        event.target === lightbox.querySelector('.jm-mfp-container') ||
        closest(event.target, '.jm-mfp-close')
      ) {
        closeFallbackLightbox();
      }
    });

    document.documentElement.classList.add('glowm-judgeme-fallback-open');
    document.body.classList.add('glowm-judgeme-fallback-open');
    document.body.appendChild(backdrop);
    document.body.appendChild(lightbox);
    positionFallbackLightbox();
  }

  function openGalleryImageIfJudgeMeMissed(event) {
    var gallery = closest(event.target, '.jdgm-gallery');
    var link = closest(event.target, '.jdgm-gallery__thumbnail-link');
    var expectedUrl = getThumbnailFullSizeUrl(event.target);

    if (!gallery || !link || !gallery.classList.contains('jdgm-gallery--glowm-expanded') || !expectedUrl) {
      return;
    }

    window.setTimeout(function () {
      if (document.querySelector('.jm-mfp-img')) {
        return;
      }

      openFallbackLightbox(expectedUrl);
    }, 220);
  }

  function rememberSelectedGalleryImage(event) {
    var expectedUrl = getThumbnailFullSizeUrl(event.target);

    if (!expectedUrl) {
      return;
    }

    [0, 60, 180, 400, 800].forEach(function (delay) {
      window.setTimeout(function () {
        syncOpenGalleryImage(expectedUrl);
      }, delay);
    });
  }

  function buildFallbackGalleryHtml(review) {
    var pictures = review && Array.isArray(review.pictures_urls) ? review.pictures_urls : [];
    var html = '';

    pictures.forEach(function (picture) {
      var thumbnailUrl = getPictureUrl(picture, 'compact');
      var originalUrl = getPictureUrl(picture, 'original') || thumbnailUrl;

      if (!thumbnailUrl) {
        return;
      }

      html += [
        "<div class='jdgm-gallery__thumbnail-link'>",
        "<div class='jdgm-gallery__thumbnail-wrapper'>",
        "<img class='jdgm-gallery__thumbnail' alt='User picture' src='",
        escapeAttribute(thumbnailUrl),
        "' data-src='",
        escapeAttribute(thumbnailUrl),
        "' data-mfp-src='",
        escapeAttribute(originalUrl),
        "' data-review-id='",
        escapeAttribute(review.uuid),
        "' />",
        '</div>',
        '</div>',
      ].join('');
    });

    return html;
  }

  function buildGalleryHtml(review) {
    if (window.jdgm && window.jdgm.templates && typeof window.jdgm.templates.photoGalleryThumbnail === 'function') {
      try {
        return window.jdgm.templates.photoGalleryThumbnail({
          review: review,
          preload: true,
        });
      } catch (error) {
        // Fall back to a minimal version of Judge.me's thumbnail markup below.
      }
    }

    return buildFallbackGalleryHtml(review);
  }

  function hydrateGalleryImages(gallery) {
    var images = gallery.querySelectorAll('.jdgm-gallery__thumbnail');

    Array.prototype.forEach.call(images, function (image) {
      var imageUrl = image.getAttribute('src') || image.getAttribute('data-src');
      var wrapper = closest(image, '.jdgm-gallery__thumbnail-wrapper');

      if (imageUrl && !image.getAttribute('src')) {
        image.setAttribute('src', imageUrl);
      }

      if (wrapper) {
        wrapper.classList.remove('jdgm--loading');
      }
    });
  }

  function renderReviewGalleries(root) {
    var galleries = (root || document).querySelectorAll
      ? (root || document).querySelectorAll('.jdgm-gallery')
      : [];

    Array.prototype.forEach.call(galleries, function (gallery, index) {
      var dataElement = gallery.querySelector('.jdgm-gallery-data');
      var reviews = getGalleryReviews(dataElement);
      var html = '';

      if (gallery.querySelector('.jdgm-gallery__thumbnail')) {
        hydrateGalleryImages(gallery);
        return;
      }

      reviews.forEach(function (review) {
        if (review && Array.isArray(review.pictures_urls) && review.pictures_urls.length) {
          html += buildGalleryHtml(review);
        }
      });

      if (!html) {
        return;
      }

      gallery.insertAdjacentHTML('beforeend', html);
      gallery.setAttribute('data-loaded', 'true');

      if (!gallery.getAttribute('data-id')) {
        gallery.setAttribute('data-id', 'glowm-review-gallery-' + (index + 1));
      }

      hydrateGalleryImages(gallery);
    });
  }

  function refreshJudgeMeEnhancements(widget) {
    if (!window.jdgm) {
      renderReviewGalleries(widget || document);
      normalizeJudgeMePagination(widget || document);
      return;
    }

    try {
      if (typeof window.jdgm.customizeReviews === 'function') {
        window.jdgm.customizeReviews();
      }

      if (typeof window.jdgm.setupMediaGallery === 'function' && window.jdgm.$) {
        window.jdgm.setupMediaGallery(window.jdgm.$(widget));
      }

      renderReviewGalleries(widget || document);
      normalizeJudgeMePagination(widget || document);
    } catch (error) {
      // Judge.me owns these optional enhancements; pagination should still work without them.
      renderReviewGalleries(widget || document);
      normalizeJudgeMePagination(widget || document);
    }
  }

  function parsePageNumber(value) {
    var page = parseInt(String(value || '').replace(/[^\d]/g, ''), 10);

    return isNaN(page) ? 0 : page;
  }

  function getCurrentPage(paginate) {
    var current = paginate.querySelector(
      '.jdgm-paginate__page.jdgm-curt, ' +
        '.jdgm-paginate__page.jdgm-curr, ' +
        '.jdgm-paginate__page.jdgm-curr-page, ' +
        '.jdgm-paginate__page--active, ' +
        '.jdgm-paginate__page[aria-current="true"], ' +
        '.jdgm-paginate__page[aria-current="page"]'
    );

    if (!current) {
      current = paginate.querySelector('.jdgm-paginate__page[data-page]');
    }

    return parsePageNumber((current && current.dataset && current.dataset.page) || (current && current.textContent)) || 1;
  }

  function getTotalPages(paginate) {
    var last = paginate.querySelector('.jdgm-paginate__last-page[data-page]');
    var maxPage = parsePageNumber(last && last.dataset && last.dataset.page);
    var pages = paginate.querySelectorAll('.jdgm-paginate__page[data-page]');

    Array.prototype.forEach.call(pages, function (page) {
      var isDirectional =
        page.classList.contains('jdgm-paginate__next-page') ||
        page.classList.contains('jdgm-paginate__prev-page') ||
        page.classList.contains('jdgm-paginate__first-page') ||
        page.classList.contains('jdgm-paginate__last-page');

      if (!isDirectional) {
        maxPage = Math.max(maxPage, parsePageNumber(page.dataset.page || page.textContent));
      }
    });

    return maxPage || pages.length || 1;
  }

  function buildPaginationPage(pageNumber, currentPage) {
    var link = document.createElement('a');

    link.className = 'jdgm-paginate__page' + (pageNumber === currentPage ? ' jdgm-curt' : '');
    link.dataset.page = String(pageNumber);
    link.setAttribute('aria-label', 'Page ' + pageNumber);
    link.setAttribute('tabindex', '0');
    link.setAttribute('role', 'button');
    link.textContent = String(pageNumber);

    if (pageNumber === currentPage) {
      link.setAttribute('aria-current', 'page');
    }

    return link;
  }

  // Thin chevron icons — inherit the link's color (currentColor) and size (1em)
  // so the controls read as crisp glyphs instead of literal "> >|" text.
  var ICON_NEXT =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" ' +
    'style="width:1em;height:1em;display:inline-block;vertical-align:-0.15em">' +
    '<polyline points="9 5 16 12 9 19"></polyline></svg>';
  var ICON_LAST =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" ' +
    'style="width:1em;height:1em;display:inline-block;vertical-align:-0.15em">' +
    '<polyline points="6 5 13 12 6 19"></polyline><line x1="18" y1="5" x2="18" y2="19"></line></svg>';
  var ICON_PREV =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" ' +
    'style="width:1em;height:1em;display:inline-block;vertical-align:-0.15em">' +
    '<polyline points="15 5 8 12 15 19"></polyline></svg>';
  var ICON_FIRST =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" ' +
    'style="width:1em;height:1em;display:inline-block;vertical-align:-0.15em">' +
    '<line x1="6" y1="5" x2="6" y2="19"></line><polyline points="18 5 11 12 18 19"></polyline></svg>';

  function buildPaginationControl(pageNumber, iconHtml, variantClass, ariaLabel) {
    var link = document.createElement('a');

    // Reuse jdgm-paginate__page so it inherits the numbered-link styling and is
    // picked up by the click handler's SELECTOR; glowm-paginate__nav marks it as
    // one of our injected controls (kept out of Judge.me's own control classes).
    link.className = 'jdgm-paginate__page glowm-paginate__nav ' + variantClass;
    link.dataset.page = String(pageNumber);
    link.setAttribute('aria-label', ariaLabel);
    link.setAttribute('tabindex', '0');
    link.setAttribute('role', 'button');
    link.innerHTML = iconHtml;

    return link;
  }

  var WINDOW_SIZE = 9;

  function normalizeJudgeMePagination(root) {
    var paginates = (root || document).querySelectorAll('.jdgm-paginate');

    Array.prototype.forEach.call(paginates, function (paginate) {
      var totalPages = getTotalPages(paginate);
      var currentPage = Math.max(1, Math.min(getCurrentPage(paginate), totalPages));

      // Sliding window of up to 9 consecutive page numbers centred on the
      // current page (clamped to the ends), so pages beyond the first 9 become
      // visible and reachable as you navigate — instead of a fixed 1..9 that
      // never moved even after jumping to the last page.
      var windowSize = Math.min(WINDOW_SIZE, totalPages);
      var start = currentPage - Math.floor((windowSize - 1) / 2);
      start = Math.max(1, Math.min(start, totalPages - windowSize + 1));
      var end = start + windowSize - 1;

      var signature = [totalPages, start, end, currentPage].join(':');

      if (paginate.dataset.glowmPaginationSignature === signature) {
        return;
      }

      paginate.dataset.glowmPaginationSignature = signature;
      paginate.innerHTML = '';

      // "first" (|<) and "prev" (<) whenever there are pages before the current
      // one. data-page + jdgm-paginate__page let the existing click handler load
      // them via the same AJAX path.
      if (currentPage > 1) {
        paginate.appendChild(
          buildPaginationControl(1, ICON_FIRST, 'glowm-paginate__first', 'First page')
        );
        paginate.appendChild(
          buildPaginationControl(Math.max(currentPage - 1, 1), ICON_PREV, 'glowm-paginate__prev', 'Previous page')
        );
      }

      for (var pageNumber = start; pageNumber <= end; pageNumber += 1) {
        paginate.appendChild(buildPaginationPage(pageNumber, currentPage));
      }

      // "next" (>) and "last" (>|) whenever there are pages beyond the current
      // one. data-page + jdgm-paginate__page let the existing click handler load
      // them via the same AJAX path.
      if (currentPage < totalPages) {
        paginate.appendChild(
          buildPaginationControl(Math.min(currentPage + 1, totalPages), ICON_NEXT, 'glowm-paginate__next', 'Next page')
        );
        paginate.appendChild(
          buildPaginationControl(totalPages, ICON_LAST, 'glowm-paginate__last', 'Last page')
        );
      }
    });
  }

  function scheduleReviewGalleryRefresh() {
    renderReviewGalleries(document);
    normalizeJudgeMePagination(document);

    [1000, 2500, 5000].forEach(function (delay) {
      window.setTimeout(function () {
        renderReviewGalleries(document);
        normalizeJudgeMePagination(document);
      }, delay);
    });
  }

  function scrollToWidget(widget, body) {
    var target = body || widget;
    var top = target.getBoundingClientRect().top + window.pageYOffset - 120;

    window.scrollTo({
      top: Math.max(top, 0),
      behavior: 'smooth',
    });
  }

  function showLoading(widget, isLoading) {
    var spinner = widget.querySelector('.jdgm-rev-widg__paginate-spinner-wrapper');
    var body = widget.querySelector('.jdgm-rev-widg__body');

    widget.classList.toggle('jdgm-pagination-fallback--loading', isLoading);

    if (spinner) {
      spinner.style.display = isLoading ? '' : 'none';
    }

    if (body) {
      body.style.opacity = isLoading ? '0.45' : '';
    }
  }

  async function handleClick(event) {
    var button = closest(event.target, SELECTOR);

    if (!button || !button.dataset.page) {
      return;
    }

    var paginate = closest(button, '.jdgm-paginate');
    var widget = getWidget(button);
    var body = widget && widget.querySelector('.jdgm-rev-widg__body');
    var url = paginate && paginate.dataset.url;

    if (!paginate || !widget || !body || !url) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (button.classList.contains('jdgm-curt') || widget.dataset.jdgmFallbackLoading === 'true') {
      return;
    }

    widget.dataset.jdgmFallbackLoading = 'true';
    showLoading(widget, true);

    try {
      var response = await fetch(url + '?' + buildParams(widget, paginate, button).toString(), {
        credentials: 'omit',
      });

      if (!response.ok) {
        throw new Error('Judge.me pagination failed: ' + response.status);
      }

      var data = await response.json();

      if (!data || !data.html) {
        throw new Error('Judge.me pagination returned no HTML');
      }

      body.innerHTML = data.html;
      refreshJudgeMeEnhancements(widget);
      normalizeJudgeMePagination(widget);
      scrollToWidget(widget, body);
    } catch (error) {
      console.warn('[glow.m] Judge.me pagination fallback failed', error);
    } finally {
      delete widget.dataset.jdgmFallbackLoading;
      showLoading(widget, false);
    }
  }

  document.addEventListener('click', handleClick, true);
  document.addEventListener('touchend', handleClick, { capture: true, passive: false });
  document.addEventListener('click', revealHiddenGalleryItems, true);
  document.addEventListener('touchend', revealHiddenGalleryItems, { capture: true, passive: false });
  document.addEventListener('click', rememberSelectedGalleryImage, true);
  document.addEventListener('touchend', rememberSelectedGalleryImage, { capture: true, passive: true });
  document.addEventListener('click', openGalleryImageIfJudgeMeMissed, true);
  document.addEventListener('touchend', openGalleryImageIfJudgeMeMissed, { capture: true, passive: true });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeFallbackLightbox();
    }
  });
  window.addEventListener('resize', positionFallbackLightbox);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', positionFallbackLightbox);
    window.visualViewport.addEventListener('scroll', positionFallbackLightbox);
  }

  if (window.MutationObserver) {
    var paginationRefreshTimer = null;
    var paginationObserver = new MutationObserver(function () {
      window.clearTimeout(paginationRefreshTimer);
      paginationRefreshTimer = window.setTimeout(function () {
        normalizeJudgeMePagination(document);
      }, 50);
    });

    if (document.body) {
      paginationObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  ensureModalStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleReviewGalleryRefresh);
  } else {
    scheduleReviewGalleryRefresh();
  }
})();
